import { InjectionToken } from '@angular/core';
import { CmsDataUrl } from '@common/util-models';

export const cmsDataUrlToken = new InjectionToken<CmsDataUrl>('CMS Data Urls');
